import React from 'react';

import classnames from 'classnames';

import Validated from 'components/util/Validated';

import UserSchemas from 'schemas/users_schemas';

import { Form } from 'common/components';

const UsersForm = ({
  id = '',
  companyId = '',
  errors = {},
  isLoading = false,
  isLoadingRoles = false,
  isSubmitted = false,
  handleSubmit = () => {},
  handleValueChange = () => {},
  roles = [],
  // feature/acceso-subcompanias: only root or the Administrador see the field
  canAssignSubcompanies = false,
  subcompanyOptions = [],
  handleSubcompaniesChange = () => {},
  t = (k) => k,
  values = {},
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row mt-3 align-items-center">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.email) || {}}
            name={'email'}
            label={t('users.fields.email')}
            placeholder={t('users.fields.email')}
            handleChange={handleValueChange}
            errorPrefix={'users.email'}
            t={t}
            value={values.email}
            readOnly={!!id}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldSelect
            autoFocus={true}
            error={(isSubmitted && errors.roleId) || {}}
            name={'roleId'}
            isLoading={isLoadingRoles}
            label={t('users.fields.roleId')}
            handleChange={handleValueChange}
            value={values.roleId}
          >
            {roles.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </Form.FieldSelect>
        </div>
        {/* A root user sees every subcompany and is not edited by users.update:
            no selector, only the note. */}
        {canAssignSubcompanies && values.root === true && (
          <div className="col-sm-12 col-md-4">
            <small className="text-muted">{t('users.fields.root_all_subcompanies')}</small>
          </div>
        )}
        {canAssignSubcompanies && values.root !== true && (
          <div className="col-sm-12 col-md-4">
            <Form.FieldMultiSelect
              name={'subcompaniesSelection'}
              label={t('users.fields.subcompanies')}
              placeholder={t('users.fields.all_subcompanies')}
              options={subcompanyOptions}
              value={values.subcompaniesSelection}
              handleChange={handleSubcompaniesChange}
              t={t}
            />
          </div>
        )}
      </div>
      <div className="col-md-12">
        <Form.Button
          text={t('actions.save')}
          isLoading={isLoading}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${companyId}/users`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isLoading,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated(UserSchemas.edit)(UsersForm);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/components/UserForm.js